import { render } from "./count-up.vue?vue&type=template&id=3b3f180a"
import script from "./count-up.vue?vue&type=script&lang=js"
export * from "./count-up.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__